import { createContext } from "react";

export const CardGroupContext = createContext(false);
